import React from 'react'
import { BurgerNav } from '../../elements/icons/burgerNav'
import Cancel from '../../elements/icons/cancel'

export const BurgerNavMenu = (props) => {
    let strokeColor = '#000';
    let color = '#000';

    if (props.backgroundColor && props.backgroundColor === 'transparent') {
        strokeColor = '#fff';
        color = '#fff';
    }

    return (
     <div className={'d-flex align-self-center'} onClick={() => props.onNavClick()}>
        {!props.isOpen ?  
            <BurgerNav stroke={strokeColor} color={color} />
        :
            <Cancel style={{width:'40px', padding:'0 0 0 15px'}} color="#999" stroke={strokeColor} />
        }
    </div>

    )
};
